
    import { computed, defineComponent, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import { overlayComposition } from '@/core/modules/overlay/services';

    import Slider from '@vueform/slider';

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

        /**
         * Top elements
         */
        const toggleActive = ref<string>('infection');
        const toggleItems: string[] = ['infection', 'presence'];

        function updateToggleActive (item: string) {
            toggleActive.value = item;
        }

        const severity: string[] = ['low', 'mid', 'high'];
        const severityActive = ref<number>(2);

        function severityActiveConvert (severity: number): number {
            let _severity = severityActive.value;
            _severity = severity < 1 && severity > 0 ? 1 : _severity;
            _severity = severity < 2 && severity > 1 ? 2 : _severity;
            _severity = severity < 3 && severity > 2 ? 3 : _severity;
            _severity = severity < 4 && severity > 3 ? 4 : _severity;
            _severity = severity < 5 && severity > 4 ? 5 : _severity;

            return _severity;
        }

        /**
         * Boxes
         */
        const boxesLeft: any[] = ['upper-airways', 'mouth', 'lungs', 'cardio', 'immune', 'liver', 'gastrointestinal'];
        const boxesRight: any[] = ['urinary', 'female-reproductive', 'male-reproductive', 'nervous', 'eye', 'mammary', 'skin'];

        const severityInfection: any = [
            {severity: 'lowest', items: ['immune']},
            {severity: 'low', items: ['female-reproductive']},
            {severity: 'mid', items: ['upper-airways', 'lungs', 'cardio', 'liver', 'urinary', 'nervous', 'eye', 'mammary', 'skin']},
            {severity: 'high', items: ['mouth', 'gastrointestinal', 'male-reproductive']}
        ];
        
        const severityPresence: any = [
            { severity: 'lowest', items: ['liver', 'female-reproductive', 'skin']},
            { severity: 'low', items: ['male-reproductive', 'nervous', 'eye']},
            { severity: 'mild', items: ['cardio', 'mammary']},
            { severity: 'mid', items: ['immune']},
            { severity: 'high', items: ['upper-airways', 'urinary', 'mouth', 'lungs', 'gastrointestinal']}
        ];

        function checkSeverity (box: string) {
            let severityLevel = '';

            if (toggleActive.value === 'infection') {
                severityInfection.forEach((_: any) => {
                    if (_.items.includes(box)) {
                        severityLevel = _.severity;
                    }
                });
            } else {
                severityPresence.forEach((_: any) => {
                    if (_.items.includes(box)) {
                        severityLevel = _.severity;
                    }
                });
            }

            return severityLevel;
        }

		return { 
            endpointId,
            boxesLeft,
            boxesRight,
            checkSeverity,
            toggleActive,
            toggleItems,
            updateToggleActive,
            severityActive,
            severity,
            severityActiveConvert
        }
	}

    export default defineComponent({
        components: {
            Slider
        },
        setup() {
            return { ...overlayComposition(), ...bespokeComposition() }
        },
    })
